<template>
    <div class="container">
      <b-card tag="article" class="mb-2">
        <div class="row">
            <div class="col-xs-12 col-sm-12 col-lg-12 col-md-12">
              <label
                  for="onerilavoro"
                  class="h5"
              >Seleziona file oneri lavoro xlsx: </label>
                <ejs-uploader ref="onerilavoro" id='onerilavoro' name="onerilavoro" :asyncSettings="path"
                              :removing="addJWTHeaders" :autoUpload="false"
                              :uploading="onFileUpload" :success="afterUpload"
                ></ejs-uploader>
            </div>
            <div class="col-xs-12 col-sm-12 col-lg-12 col-md-12 text-right mt-1" v-show="showDownload">
              <ejs-button id="downloadMinistero" cssClass="e-flat"
                @click.native="downloadMinistero()">Scarica file Ministero</ejs-button>
              <ejs-button id="downloadConsLav" cssClass="e-flat"
                @click.native="downloadConsLav()">Scarica file consulente lavoro</ejs-button>
            </div>
        </div>
      </b-card>
    </div>
</template>
<script>
import Vue from 'vue'
import useJwt from '@/auth/jwt/useJwt'
// import { createElement, isNullOrUndefined, detach, EventHandler } from '@syncfusion/ej2-base';

import { CardPlugin } from 'bootstrap-vue'
import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons'
import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs'
import { createElement } from '@syncfusion/ej2-base'

const uploadEle = createElement('span', { className: 'prova' })
uploadEle.innerHTML = ' '
const clearEle = createElement('span', { className: 'remove e-icons' })
clearEle.innerHTML = 'Clear All'

const axios = require("axios");
Vue.use(ButtonPlugin)
Vue.use(CardPlugin)
Vue.use(UploaderPlugin)

export default {
  data() {
    return {
      d: [],
      showDownload: false,
      fileMinisteroUrl: "",
      fileConsulenteLavoroUrl: "",
      path: {
        saveUrl: `${process.env.VUE_APP_API_ENDPOINT}/demo/api/bilancioministero/import_oneri_lavoro`,
      },
      buttons: {
        browse: 'Choose file',
        clear: clearEle,
        upload: uploadEle,
      },
    }
  },
  methods: {
    // per toast
    makeToast(variant = null, title = 'titolo', message = 'messaggio') {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 10000,
      })
    },
    addJWTHeaders(args) {
      const token = useJwt.getToken()

      useJwt.check() // qui dovrei restituire una promise per poter aspettare che venga risolta?
      args.currentRequest.setRequestHeader('Authorization', 'Bearer ' + token)
    },
    onFileUpload(args) {
      console.log("FILEDATA")
      console.log(args.fileData)

      const token = useJwt.getToken()

      useJwt.check() // qui dovrei restituire una promise per poter aspettare che venga risolta?
      args.currentRequest.setRequestHeader('Authorization', 'Bearer ' + token)
    },
    afterUpload(args) {
      // console.log(args)
      if (args.name === 'success') {
        console.log('tutto a posto')
        const risposta = JSON.parse(args.e.target.response)
        //const imgUrl = args.e.target.response.replace(/"/g, ""); // rimuovi apici dalla risposta ottenuta dal backend
        console.log(risposta['filePersonaleMinistero'])
        this.fileMinisteroUrl = risposta['filePersonaleMinistero']
        console.log(risposta['fileConsulenteLavoro'])
        this.fileConsulenteLavoroUrl = risposta['fileConsulenteLavoro']
        this.makeToast('primary', 'Info', 'Import eseguito correttamente')
        // SEGNA TUTTO OK PER ABILITARE DOWNLOAD
        this.showDownload = true
      }
    },
    downloadMinistero() {
      const url = this.fileMinisteroUrl;
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "file_ministero.xlsx");
      document.body.appendChild(link);
      link.click();
    },
    downloadConsLav() {
      const url = this.fileConsulenteLavoroUrl;
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "file_consulente_lavoro.xlsx");
      document.body.appendChild(link);
      link.click();
    },
  },
}
</script>
<style>
@import "~@syncfusion/ej2-base/styles/bootstrap.css";
@import "~@syncfusion/ej2-buttons/styles/bootstrap.css";
@import "~@syncfusion/ej2-vue-inputs/styles/bootstrap.css";
.control-section {
  height: 100%;
  min-height: 200px;
}

button:has(> span.prova)
{
  display: none;
}
</style>
